import { templateActionTypes } from '../actions/types';
import _ from 'lodash';

const initialState = {
  templateId: null,
  templates: [],
  templateSkip: null,
  templateLimit: 16,
  hasMoreTemplate: true,
  statistic: null,
  latestStatistic: null,
  status: '',
  categories: [],
};

export function template(state = initialState, action) {
  switch (action.type) {
    case templateActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case templateActionTypes.SEARCH_REQUEST:
      if (action.tag) {
        return {
          ...state,
          [`${action.tag}Status`]: 'loading',
        };
      } else {
        return {
          ...state,
          status: 'loading',
        };
      }
    case templateActionTypes.SEARCH_SUCCESS:
      if (action.tag) {
        return {
          ...state,
          [`${action.tag}`]: action.clear
            ? action.templates
            : [..._.get(state, `${action.tag}`, []), ...action.templates],
          [`${action.tag}Skip`]: action.skip,
          [`${action.tag}Limit`]: action.limit,
          [`hasMore${action.tag}`]: action.clear ? true : action.templates.length !== 0,
          [`${action.tag}Status`]: 'success',
        };
      } else {
        return {
          ...state,
          templates: action.clear ? action.templates : [...state.templates, ...action.templates],
          templateSkip: action.skip,
          templateLimit: action.limit,
          hasMoreTemplate: action.clear ? true : action.templates.length !== 0,
          status: 'success',
        };
      }
    case templateActionTypes.SEARCH_FAILURE:
      if (action.tag) {
        return {
          ...state,
          [`${action.tag}Error`]: action.error,
          [`${action.tag}Status`]: 'failure',
        };
      } else {
        return {
          ...state,
          error: action.error,
          status: 'failure',
        };
      }
    case templateActionTypes.GET_ALL_CATEGORIES_REQUEST:
      return {
        ...state,
        status: 'loading',
      };
    case templateActionTypes.GET_ALL_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.categories,
        status: 'success',
      };
    case templateActionTypes.GET_ALL_CATEGORIES_FAILURE:
      return {
        ...state,
        error: action.error,
        status: 'failure',
      };
    case templateActionTypes.SELECT_TEMPLATE:
      return {
        ...state,
        templateId: action.templateId,
      };
    case templateActionTypes.STATISTIC_REQUEST:
      return {
        ...state,
        error: null,
      };
    case templateActionTypes.STATISTIC_SUCCESS:
      return {
        ...state,
        statistic: action.templates,
      };
    case templateActionTypes.STATISTIC_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case templateActionTypes.STATISTIC_LATEST_REQUEST:
      return {
        ...state,
        error: null,
      };
    case templateActionTypes.STATISTIC_LATEST_SUCCESS:
      return {
        ...state,
        latestStatistic: action.templates,
      };
    case templateActionTypes.STATISTIC_LATEST_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
